import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {ACTION_TYPES} from "../consts";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {EditButtonClickAnalyticsEvent} from "../models/events/edit-button-click.analytics-event";

export class EditButtonClickAnalyticsEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.editButtonClickAnalytics;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = EditButtonClickAnalyticsEvent;
  }

  async action(params) {
    const clickEvent: EditButtonClickAnalyticsEvent = new EditButtonClickAnalyticsEvent(params);

    this.analyticsService.createEvent(clickEvent);
  }
}
